const STORAGE_PREFIX = 'cxnft_funnel';

function fallbackRandomId() {
  return `${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 12)}`;
}

export function createId(prefix = 'id') {
  const randomId =
    typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID()
      : fallbackRandomId();

  return `${prefix}_${randomId}`;
}

export function createEventId(eventName) {
  const safeName = String(eventName || 'event')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_|_$/g, '');

  return createId(`evt_${safeName || 'event'}`);
}

function safeStorage(storageName) {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    return window[storageName] || null;
  } catch (error) {
    return null;
  }
}

export function getOrCreateStoredId(key, { session = false } = {}) {
  const storage = safeStorage(session ? 'sessionStorage' : 'localStorage');
  const storageKey = `${STORAGE_PREFIX}_${key}`;

  if (!storage) {
    return createId(key);
  }

  try {
    const existing = storage.getItem(storageKey);
    if (existing) {
      return existing;
    }

    const next = createId(key);
    storage.setItem(storageKey, next);
    return next;
  } catch (error) {
    return createId(key);
  }
}
